import request from '@core/request'

export const statusObj = {
  '-1': { label: '已驳回', type: 'error' },
  '0': { label: '审核中', type: 'warning' },
  '2': { label: '已发布', type: 'success' },
  '4': { label: '发布失败', type: 'danger' },
  '5': { label: '待提交', type: 'primary' },
  '6': { label: '待发布', type: 'primary' },
}

// 海外-博客文章
export function blogPublish(data) {
  return request({
    url: '/ydyl-conversion/blogPublish/listMediaNew',
    method: 'post',
    baseURL: process.env.VUE_APP_TCLOUD_BASE_API,
    data: { ...data, sourceType: 2 },
  })
}

// 海外-海外论坛
export function businessBbs(data) {
  return request({
    url: '/ydyl-conversion/businessBbs/listMediaNew',
    method: 'post',
    baseURL: process.env.VUE_APP_TCLOUD_BASE_API,
    data: { ...data, sourceType: 2 },
  })
}

// 海外-臻选媒体
export function productMarket(data) {
  return request({
    url: '/ydyl-conversion/productMarket/listMarket',
    method: 'get',
    baseURL: process.env.VUE_APP_TCLOUD_BASE_API,
    data: { ...data, sourceType: 2, _t: Date.now() },
  })
}

// 海外-博客文章删除
export function blogPublishDelete(id) {
  return request({
    url: '/ydyl-conversion/blogPublish/deleteMedia',
    method: 'post',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    data: { id },
  })
}

// 海外-海外论坛删除
export function businessBbsDelete(id) {
  return request({
    url: '/ydyl-conversion/businessBbs/deleteMedia',
    method: 'post',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    data: { id },
  })
}
// 海外-b2b删除
export function productMarketDelete(id) {
  return request({
    url: '/ydyl-conversion/productMarket/deleteMedia',
    method: 'post',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    data: { id },
  })
}
